import DesktopView from 'components/HomePage/DesktopView';
import router from 'next/router';
import {
  GrabIcon,
  FacebookIcon,
  FoodPandaIcon,
  DeliverooIcon,
  GoogleIcon,
  GrubhubLogo,
  YelpIcon,
  SurveyColorLogo,
  UberEatsLogo,
  DoorDashIcon,
} from 'assets/svg';
import { MicrositeDefaultButtons, HOME_PAGE_DEFAULT_BUTTON, MICROSITE_BUTTON_SLUG } from 'constant/constants';
import MetaHeader from 'components/MetaHeader';
import * as fbq from 'lib/fpixel';
import * as ga from 'lib/ga';
import { getMicrositeBySlug } from 'services';
import { TRACKING } from 'constant/analytics';
import { ReactNode } from 'react';
import { GetServerSideProps } from 'next';
import log from 'lib/Logger';

const ReviewConfigIcon: Record<string, ReactNode> = {
  grab_fk: <GrabIcon className="mr-15" />,
  grubhub_fk: <GrubhubLogo className="mr-15" />,
  facebook_fk: <FacebookIcon className="mr-15" />,
  foodpanda_fk: <FoodPandaIcon className="mr-15" />,
  deliveroo_fk: <DeliverooIcon className="mr-15" />,
  gmb_fk: <GoogleIcon className="mr-15" />,
  yelp_fk: <YelpIcon className="mr-15" />,
  doordash_fk: <DoorDashIcon className="mr-15" />,
  uber_eats_fk: <UberEatsLogo className="mr-15" />,
  survey_fk: <SurveyColorLogo className="mr-15" />,
};

interface BrandPageProps {
  data: Record<string, any>;
  slug: string;
}

function BrandPage({ data, slug }: BrandPageProps) {
  const { micrositeTheme } = data?.micrositeConfigDetails || {};

  const reviewConfig = data?.micrositeReviewsConfig;

  const reviewConfigPlatform = reviewConfig && Object.keys(reviewConfig)[0];

  const navigateToRoute = (name: string) => {
    fbq.buttonClickEvent({ content_name: name });
    ga.event(
      TRACKING.HOME.BUTTON?.[
        TRACKING.HOME.BUTTON_MAPPED?.[
          name as keyof typeof TRACKING.HOME.BUTTON_MAPPED
        ] as keyof typeof TRACKING.HOME.BUTTON
      ],
    );

    const path = MICROSITE_BUTTON_SLUG[name];

    if (name === HOME_PAGE_DEFAULT_BUTTON.SURVEY) {
      router.push(`${slug}${path}/${data.micrositeSurveyId}`);
    } else {
      router.push(`${slug}${path}`);
    }
  };

  return (
    <>
      <MetaHeader title={data?.name} image={data?.logoUrl} pixelId={data?.micrositePixelId} redirectBrowser={true} />
      <DesktopView
        onClickSeeLocations={() => {
          fbq.buttonClickEvent({ content_name: 'See Location' });
          ga.event(TRACKING.HOME.BUTTON.SEE_LOCATIONS);

          router.push(`${slug}/locations`);
        }}
        slug={slug}
        theme={micrositeTheme}
        brandName={data?.name}
        serviceOptions={data?.serviceOptions}
        outletCount={data?.outletCount}
        thirdPartyLinks={data?.thirdPartyLinks}
        logo={data?.logoUrl}
        reviewConfigIcon={reviewConfigPlatform && ReviewConfigIcon[reviewConfigPlatform]}
        reviewsData={reviewConfig?.[reviewConfigPlatform]}
        buttons={data?.micrositebuttonAttributeConfig || MicrositeDefaultButtons}
        isFoodDelivery={data?.isFoodDelivery}
        isReservation={data?.isReservation}
        isMenu={data?.micrositeFoodMenuId}
        isSurvey={data?.micrositeSurveyId}
        navigateTo={navigateToRoute}
        showBrandName={!data?.micrositeBlacklistComponents?.includes('brandName')}
        micrositeData={data}
      />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async ({ params, req }) => {
  try {
    const { data } = await getMicrositeBySlug(req, params?.slug);
    if (data.status) {
      return { props: { data, slug: params?.slug } };
    }
    log.error('Unexpcted error occured while fetching the microsite:', data);
    return { notFound: true };
  } catch (err) {
    log.error('Error while fetching the microsite:', params, err);
    return {
      notFound: true,
    };
  }
};

export default BrandPage;
